import { render, staticRenderFns } from "./Alamos.vue?vue&type=template&id=64eca796"
import script from "./Alamos.vue?vue&type=script&lang=js"
export * from "./Alamos.vue?vue&type=script&lang=js"
import style0 from "./Alamos.vue?vue&type=style&index=0&id=64eca796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports